import React from 'react';
import { useParams } from 'react-router-dom';
import Page from './Page';
import { QuestionsList } from './QuestionsList';

export default function TournamentQuestionsPage() {
    const params = useParams<{ number: string; round: string }>();
    const number = Number(params.number);
    const [season, level] = params.round.split('-').map(s => s.toUpperCase());

    return (
        <Page>
            <QuestionsList
                number={number}
                season={season}
                level={level}
                type="LIVE"
                paperMode="PAGES"
            />
        </Page>
    );
}
